import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center pt-16 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20artistic%20abstract%20fashion%20collage%20with%20gentle%20watercolor%20texture%20and%20scattered%20product%20silhouettes%20like%20sneakers%20and%20clothing%20items%20in%20warm%20cream%20and%20beige%20tones%20dreamy%20defocused%20background%20soft%20natural%20daylight%20editorial%20magazine%20quality%20elegant%20minimalist%20aesthetic%20airy%20atmospheric%20mood&width=1600&height=1000&seq=hero-bg-v2&orientation=landscape"
          alt="GTBuy Sheet fashion shopping concept"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/18 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-10 lg:px-16 max-w-screen-2xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <p className="text-sm font-medium text-background-50/80 tracking-widest uppercase mb-4">
              Smart Shopping Intelligence
            </p>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
              GTBuy Sheet
              <br />
              <span className="font-normal italic text-background-50/85">Your Smart Product</span>
              <br />
              <span className="font-normal italic text-background-50/85">Comparison System</span>
            </h1>
            <p className="mt-5 text-sm md:text-base text-background-50/70 max-w-lg mx-auto lg:mx-0 leading-relaxed">
              Compare products, discover the best deals, and shop smarter across 14 curated categories — from Shoes and Hoodies to Accessories and Perfumes.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 text-sm font-semibold bg-background-50 text-primary-700 rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
              >
                buy it now
                <i className="ri-arrow-right-up-line ml-2 text-sm"></i>
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 text-sm font-medium text-background-50 border border-background-50/40 rounded-full hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
              >
                gtbuy sheet
              </a>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:block">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20product%20flat%20lay%20with%20premium%20sneakers%20folded%20cashmere%20sweater%20leather%20watch%20and%20small%20perfume%20bottle%20artistically%20composed%20on%20cream%20linen%20surface%20soft%20natural%20daylight%20from%20left%20casting%20delicate%20shadows%20warm%20neutral%20tones%20clean%20editorial%20photography%20high%20end%20lifestyle%20composition&width=800&height=1000&seq=hero-product-v2&orientation=portrait"
                alt="GTBuy Sheet product showcase"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>

        <div className="mt-16 flex justify-center">
          <button
            onClick={() => {
              const el = document.getElementById('categories-section');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="flex flex-col items-center gap-2 text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
          >
            <span className="text-xs font-medium tracking-wider uppercase">Explore Categories</span>
            <i className="ri-arrow-down-line text-lg animate-bounce"></i>
          </button>
        </div>
      </div>
    </section>
  );
}